import { colors } from '../../colors';
var address = {
  addressColor: colors.graphite
};
export default address;